<template>
  <tr>
    <td rowspan="2" class="text-center px-3" colspan="2">
      <strong> {{ $t('common_words.mayus_average_farm') }}</strong>
    </td>
    <template v-for="(generalData, subcategory) in dataEvaluations">
      <td
        scope="col"
        v-if="generalData.containObjetive || generalData.general"
        :key="subcategory"
        class="text-center px-3"
      >
        <tag-legend
          :avgValue="calculateRowAVG(evaluation, subcategory)"
          :ref="`${subcategory}ByRow`"
          v-if="generalData.containObjetive"
        />
      </td>
    </template>
    <td scope="col" class="text-center px-3">
      <tag-legend
        :avgValue="
          accumulateRowAverages(evaluation, Object.keys(dataEvaluations))
        "
      />
    </td>
  </tr>
</template>
<script>
import MixinMethods from './mixin-methods';
import TagLegend from './TagLegend.vue';

export default {
  components: {
    [TagLegend.name]: TagLegend,
  },
  name: 'total-row',
  data() {
    return {
      model: {},
    };
  },
  props: {
    dataEvaluations: {
      type: Object,
    },
    evaluation: {
      type: String,
    },
    seletedData: {
      type: Object,
    },
  },
  mixins: [MixinMethods],
};
</script>
